module.exports = __webpack_public_path__ + "static/media/iothg-artwork.b8088186.jpg";